import { AddOutlined, DeleteOutline } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { Button } from "src/components/Form";
import { FC } from "react";
import { ProductGroupResponse } from "src/models/product/ProductGroupResponse";

type ProductGroupRowProps = {
  productGroup: ProductGroupResponse;
  isAdded: boolean;
  onClick: (product: ProductGroupResponse) => void;
};

export const ProductGroupRow: FC<ProductGroupRowProps> = ({ productGroup, isAdded, onClick }: ProductGroupRowProps) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      padding={2}
      borderBottom={1}
      borderColor={(theme) => theme.palette.grey[400]}
      width="100%"
    >
      <div style={{ flexGrow: 1 }}>
        <div>
          <strong>{productGroup.description}</strong>
        </div>
        <div>ID: {productGroup.id}</div>
      </div>
      {isAdded ? (
        <Button type="iconOnly" onClick={() => onClick(productGroup)}>
          <DeleteOutline />
        </Button>
      ) : (
        <Button type="iconOnly" icon={<AddOutlined />} onClick={() => onClick(productGroup)} />
      )}
    </Stack>
  );
};
